import React from 'react';
import { Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface props {
    title: string, meta: Array<string>, description?: string, url: string
}

function HomeItem(props: props) {

    const meta = props.meta.map((item, index) => {
        return (
            <li key={index}>
                {item}
            </li>
        )

    })
    return (
        <Col
            md={{ span: 8, offset: 2 }}
        >
            <Link to={props.url}>
                <ul className="point-cursor project-item color-white">
                    <li>
                        <h1>{props.title}</h1>
                    </li>
                    <li>
                        <ul className="meta-list">
                            {meta}
                        </ul>
                    </li>
                    <li>
                        <span>{props.description}</span>
                    </li>
                </ul>
            </Link>
        </Col>

    );
}

export default HomeItem;